import { Step } from "../types";

export const STEPS: Step[] = [
  { key: 'step-1', label: 'Patient Type', path: '/bookonline/step-1' },
  { key: 'step-2', label: 'Treatment Type', path: '/bookonline/step-2' },
  { key: 'step-3', label: 'Time Slots', path: '/bookonline/step-3' },
  { key: 'step-4', label: 'Patient Details', path: '/bookonline/step-4' },
  { key: 'confirmation', label: 'Confirmation', path: '/bookonline/confirmation' },
];

export const SMALL_SCREEN_DAYS_TO_SHOW = 3;
export const LARGE_SCREEN_DAYS_TO_SHOW = 7;
export const TIME_SLOT_INCREMENT_MINUTES = 30;
export const MIN_SLOTS_THRESHOLD = 5;
export const EXTENDED_SLOTS_DAYS = 30;
export const DEFAULT_SLOTS_LOOKUP_MONTHS = 12;

export const SMART_BOOKING_PARAMS = ['appointment_type', 'patient_id'];

export const LEGAL_PAGES = {
  privacyPolicy: 'privacy-policy',
  termsOfUse: 'terms-of-use',
} as const;

export const REQUEST_POLL_INTERVAL_MS = 3000; //3 seconds
export const REQUEST_POLL_TIMEOUT_MS = 120 * 1000; //2 minutes

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', "utm_ci", "utm_channel", "utm_ad", "utm_cm"];
export const ALL_ATTRIBUTION_PARAMS = [...UTM_PARAMS];
